<template>
  <el-popover
    class="help-tip-wrap"
    popper-class="help-tip-popper"
    :placement="placement"
    width="260"
    :title="title"
    trigger="hover"
    :content="content"
  >
    <template v-if="$slots.default">
      <slot></slot>
    </template>
    <i slot="reference" class="el-icon-question help-tip"></i>
  </el-popover>
</template>

<script>
// Значок «?» с подсказкой при наведении - один вид для всех подсказок внесения данных.
// Текст - в content, разметка (например, легенда цветов) - в слоте по умолчанию
export default {
  name: "helpTip",
  props: {
    title: { type: String, default: "" },
    content: { type: String, default: "" },
    placement: { type: String, default: "bottom-end" },
  },
};
</script>

<style scoped>
/* Рядом с длинным текстом значок не сжимается */
.help-tip-wrap {
  flex-shrink: 0;
}
.help-tip {
  color: #c0c4cc;
  font-size: 16px;
  vertical-align: middle;
  cursor: help;
  transition: color 0.15s;
}
.help-tip:hover {
  color: #409eff;
}
</style>

<style>
/* Подсказка выводится в body, вне #app - шрифт приложения задаём ей явно, как у #app */
.help-tip-popper {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>
